import { axiosInstance } from "../../api/Axios";
import { useEffect } from "react";
import { toast } from 'react-toastify';
import useRefreshToken from "./useRefreshToken";
import { useAuth } from "../AuthContext";

const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const requestInterceptor = axiosInstance.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth?.access}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );
        
        const responseInterceptor = axiosInstance.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const accessToken = await refresh();
                    prevRequest.headers['Authorization'] = `Bearer ${accessToken}`;
                    return axiosInstance(prevRequest);
                }
                if (error?.response?.status === 400 && error?.response?.data?.detail === "Token is invalid or expired") {
                    window.location.reload();
                }

                // Manejo global de errores: mostrar cualquier mensaje del backend
                if (error?.response && error?.response.data) {
                    const data = error.response.data;
                    let msg = 'Error en la solicitud.';
                    if (typeof data === 'string') {
                        // Detectar si es HTML (respuesta de error del servidor)
                        if (data.trim().startsWith('<!DOCTYPE html') || data.trim().startsWith('<html')) {
                            msg = 'Error, contacte soporte';
                        } else {
                            msg = data;
                        }
                    } else if (typeof data === 'object') {
                        if (data.detail) msg = data.detail;
                        else if (data.message) msg = data.message;
                        else if (data.error) msg = data.error;
                        else if (data.type) msg = `[${data.type}]`;
                        // Errores de validación tipo { campo: ["msg"] }
                        else {
                            const firstKey = Object.keys(data)[0];
                            if (firstKey && Array.isArray(data[firstKey])) {
                                msg = data[firstKey][0];
                            }
                        }
                    }
                    toast.error(msg);
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axiosInstance.interceptors.request.eject(requestInterceptor);
            axiosInstance.interceptors.response.eject(responseInterceptor);
        };

    }, [auth, refresh]);

    return axiosInstance;
}

export default useAxiosPrivate;
